const snakeCaseCode = `import { snakeCase } from 'cristatus';

const snakeCaseString = snakeCase("helloWorld"); //hello_world
`;

export default snakeCaseCode;
